<template>
  <div class="print-module">
    <!-- 打印模板放到这里 -->
    <div id="print_tel">
      <div style="text-align: center;margin: 20px 0;font-weight: bold;font-size: 18px;">{{ title }}</div>
      <div v-if="!status" class="table" style="margin: 0 auto; padding: 0;font-family: Arial, 宋体, Helvetica, sans-serif;display: table; width: 100%; border-collapse: collapse;">
        <div class="table-tr" style="display: table-row;border-bottom:1px black solid ;height: 20px;">
          <div v-for="(item,index) in tol" :key="index" class="table-th" style="display: table-cell;font-weight: bold;height: 100%;text-align: center;vertical-align: middle;min-width: 100px;">
            {{ item.name }}
          </div>
        </div>
        <div v-for="(item,index) in tabledata" :key="index" class="table-tr" style="display: table-row; height: 35px; border-bottom:1px black dashed ">
          <div v-for="(a,b) in tol" :key="b" class="table-td" style="display: table-cell;  text-align: center;vertical-align: middle;">
            {{ item[a.prop] }}
          </div>
        </div>
      </div>
      <div v-if="status == 2" class="table" style="margin: 0 auto; padding: 0;font-family: Arial, 宋体, Helvetica, sans-serif;display: table; width: 100%; border-collapse: collapse;">
        <div class="table-tr" style="display: table-row;border-bottom:1px black solid ;height: 20px;">
          <div v-for="(item,index) in tol" :key="index" class="table-th" style="display: table-cell;font-weight: bold;height: 100%;text-align: center;vertical-align: middle;min-width: 100px;">
            {{ item.name }}
          </div>
        </div>
        <div v-for="(item,index) in tabledata" :key="index" class="table-tr" style="display: table-row; height: 35px; border-bottom:1px black dashed ">
          <div v-for="(a,b) in tol" :key="b" class="table-td" style="padding: 10px 0 !important;display: table-cell;  text-align: center;vertical-align: middle;">
            <div v-if="a.name == '剩余可划扣的项目/产品'">
              <p v-for="(c,d) in item[a.prop]" :key="d" style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">{{ c.dictItemName || c.productName }}</p>
            </div>
            <div v-else-if="a.name == '剩余次数'">
              <div v-if="item.countLimitType == 3">{{ item.beUsedCount }}</div>
              <div v-else>
                <p v-for="(e,f) in item[a.prop]" :key="f" style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">{{ item.countLimitType == 1 ? e.residueCount : '无限' }}</p>
              </div>
            </div>
            <div v-else>{{ item[a.prop] }}</div>
          </div>
        </div>
      </div>
    </div>
    <iframe id="print" src="about:blank" border="0" frameborder="0" style="display:none;"></iframe>
  </div>
</template>
<script>
export default {
  name: 'PrintModule',
  data() {
    return {
      title: '',
      tol: [],
      tabledata: []
    };
  },
  methods: {
    print(options) {
      this.title = options.title;
      this.tol = options.table_tol;
      this.tabledata = options.data;
      this.status = options.status;
      // console.log(options)

      // 因为传过来的数据要渲染dom元素 所以一定要保留一段的时间去渲染
      setTimeout(() => {
        const printWin = document.querySelector('#print').contentWindow;
        const content = document.querySelector('#print_tel').innerHTML;
        const style = "<style media='print'>body{font-size:12px;} @page { size: landscape; }  </style>";
        printWin.document.open();
        printWin.document.write(style, content);
        printWin.document.close();
        printWin.print();
      }, 500);
    }
  }
};
</script>

<style scoped>
@media print {
    table {
        font-size: 99px;
    }
}
</style>
